export const STATUS_TYPES = {
  0: {
    text: '待审批',
    color: 'success'
  },
  1: {
    text: '审核不通过',
    color: 'warning'
  },
  2: {
    text: '转账失败',
    color: 'info'
  },
  3: {
    text: '转账超时',
    color: 'danger'
  },
  4: {
    text: '转账成功',
    color: 'success'
  },
  5: {
    text: '余额不足',
    color: 'warning'
  }
};
export const PAGINATION = {
  page: 1,
  size: 25
};
